module.exports = __webpack_public_path__ + "img/modifiers_icon_gray.3aa1c913.svg";